import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Пропускает только залогиненных администраторов. */
export default function AdminRoute({ children }) {
  const { token, user } = useAuth();
  if (!token)          return <Navigate to="/login"  replace />;
  if (!user?.is_admin) return <Navigate to="/"       replace />;
  return children;
}
